/**
 * Color - commonly used constant values and helpers for Genesys scripts.
 */
export class Color {
  /** White color (0xFFFFFF) */
  static readonly WHITE = 0xFFFFFF;
  /** Black color (0x000000) */
  static readonly BLACK = 0x000000;
  /** Red color (0xFF0000) */
  static readonly RED = 0xFF0000;
  /** Green color (0x00FF00) */
  static readonly GREEN = 0x00FF00;
  /** Blue color (0x0000FF) */
  static readonly BLUE = 0x0000FF;
  /** Yellow color (0xFFFF00) */
  static readonly YELLOW = 0xFFFF00;
  /** Cyan color (0x00FFFF) */
  static readonly CYAN = 0x00FFFF;
  /** Magenta color (0xFF00FF) */
  static readonly MAGENTA = 0xFF00FF;
  /** Gray color (0x808080) */
  static readonly GRAY = 0x808080;
  /** Dark gray color (0x404040) */
  static readonly DARK_GRAY = 0x404040;
  /** Light gray color (0xC0C0C0) */
  static readonly LIGHT_GRAY = 0xC0C0C0;
  /** Orange color (0xFFA500) */
  static readonly ORANGE = 0xFFA500;
  /** Purple color (0x800080) */
  static readonly PURPLE = 0x800080;
  /** Brown color (0x8B4513) */
  static readonly BROWN = 0x8B4513;

  /** Generates a random color value. */
  static random(): number {
    return Math.floor(Math.random() * 0xFFFFFF);
  }
}
